import { useEffect, useState } from "react";

export function useDeviceTier() {
    const [tier, setTier] = useState("full");

    useEffect(() => {
        const compute = () => {
            const narrow = window.matchMedia("(max-width: 768px)").matches;
            const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            const cores = navigator.hardwareConcurrency || 8;
            const memory = navigator.deviceMemory || 8;
            if (reduced || narrow || cores <= 4 || memory <= 4) setTier("lite");
            else setTier("full");
        };
        compute();
        window.addEventListener("resize", compute);
        return () => window.removeEventListener("resize", compute);
    }, []);

    return tier;
}
